import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-5 text-center" data-testid="not-found-page">
      <Seo title="Page not found | Lab2o" path="/404" description="This page does not exist." noindex />
      <p className="font-plexmono text-[10px] tracking-[0.25em] uppercase text-slate-400">404</p>
      <h1 className="mt-3 font-chivo font-extrabold tracking-tighter text-4xl text-slate-950">Page not found</h1>
      <p className="mt-3 text-sm text-slate-600 max-w-sm">
        The page you're looking for doesn't exist. Head back to the shop.
      </p>
      <Link
        to="/"
        className="mt-8 bg-slate-950 text-white px-8 py-3.5 font-plexmono text-xs tracking-[0.2em] uppercase hover:bg-slate-800 transition-colors"
        data-testid="not-found-home-button"
      >
        Back to shop
      </Link>
    </div>
  );
}
